export default __webpack_public_path__ + "static/firebaseLogo-b90cac658c69df90c8cf65746f79db97.svg";